import { deleteBiddingSpotApprovalRequest } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'

import { spotApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * スポット入札 承認依頼 削除 mutation hook (楽観ロック使用)。
 * onSuccess で list / detail query を invalidate する。
 */
export function useDeleteBiddingSpotApprovalRequest(): InvalidatingMutationResultFor<
  typeof deleteBiddingSpotApprovalRequest
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      deleteBiddingSpotApprovalRequest,
      spotApprovalRequestInvalidationKeys,
    ),
  )
}
